import React from "react";
import { DiscordIcon, DiscordStatus } from "../DiscordLinkWindow";

type DiscordMenuItemProps = {
  status: DiscordStatus | null;
  onClick: () => void;
};

// 상단 계정 메뉴(로그아웃 위)에 표시되는 디스코드 연동 상태 항목.
// - 연동+재적: "{닉네임} 연동됨"
// - 연동됐지만 서버 미참여(추방/이탈): "{닉네임} 서버 미참여"
// - 미연동: "디스코드 연동하기"
// 클릭하면 연동 모달을 열어 연동/재확인할 수 있다.
export default function DiscordMenuItem({ status, onClick }: DiscordMenuItemProps) {
  let label: string;
  let statusColor = "#9aa0a6";

  if (!status || !status.linked) {
    label = "디스코드 연동하기";
  } else if (!status.member) {
    label = `${status.discordName ?? "디스코드"} · 서버 미참여`;
    statusColor = "#e0803a";
  } else {
    label = `${status.discordName ?? "디스코드"} · 연동됨`;
    statusColor = "#43b581";
  }

  return (
    <li onClick={onClick}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <DiscordIcon size={16} color="#5865F2" />
        <span style={{ color: statusColor }}>{label}</span>
      </span>
    </li>
  );
}
